import Vue from 'vue'
import App from '@/App.vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { locale } from 'devextreme/localization'
import InstantSearch from 'vue-instantsearch'
import router from '@/router/index.js'
import store from '@/store/index.js'
import i18n from './i18n.js'
import VueProgressBar from 'vue-progressbar'
import 'element-ui/lib/theme-chalk/index.css'
import Vuetify from 'vuetify'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import 'jquery-ui/themes/base/all.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css'
// import 'devexpress-reporting/dist/css/dx-reporting-skeleton-screen.css'
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css'

import '@devexpress/analytics-core/dist/css/dx-querybuilder.css'
import 'devexpress-reporting/dist/css/dx-reportdesigner.css'
import 'devexpress-dashboard/dist/css/dx-dashboard.light.css'
import 'bootstrap-vue/src/icons.scss'

import 'vuetify/dist/vuetify.min.css'
import '@/assets/scss/main.scss'
import '../vee-validate.js'

import LoginLayout from '@/layouts/LoginLayout.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import EmptyPageLayout from '@/layouts/EmptyPageLayout.vue'

locale(navigator.language)

Vue.component('login-layout', LoginLayout)
Vue.component('default-layout', DefaultLayout)
Vue.component('empty-page-layout', EmptyPageLayout)

Vue.use(require('vue-moment'))
Vue.use(InstantSearch)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuetify)
Vue.use(VueProgressBar, {
  color: '#0CCFB0',
  failedColor: '#cf0c2b',
  thickness: '3px',
  autoFinish: false,
  position: 'relative'
})

Vue.config.productionTip = false

new Vue({
  vuetify: new Vuetify(),
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
